'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  border-radius: 50%;\n  bottom: 0;\n  color: ', ';\n  display: flex;\n  font-family: sans-serif;\n  font-size: 600%;\n  height: 0;\n  justify-content: center;\n  padding-bottom: calc(18% - ', 'px);\n  padding-top: calc(18% - ', 'px);\n  position: absolute;\n  right: 0;\n  user-select: none;\n  width: 36%;\n'], ['\n  align-items: center;\n  border-radius: 50%;\n  bottom: 0;\n  color: ', ';\n  display: flex;\n  font-family: sans-serif;\n  font-size: 600%;\n  height: 0;\n  justify-content: center;\n  padding-bottom: calc(18% - ', 'px);\n  padding-top: calc(18% - ', 'px);\n  position: absolute;\n  right: 0;\n  user-select: none;\n  width: 36%;\n']);

var _colors = require('HubStyleTokens/colors');

var _Constants = require('../../Constants');

var _AvatarContentHolder = require('./AvatarContentHolder');

var _AvatarContentHolder2 = _interopRequireDefault(_AvatarContentHolder);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SVGIcon = require('./SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SocialBadgeWrapper = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'SocialBadge__SocialBadgeWrapper'
})(_templateObject, _colors.OLAF, _Constants.BORDERWIDTH, _Constants.BORDERWIDTH);

var SocialBadge = function SocialBadge(props) {
  var socialNetwork = props.socialNetwork;

  return _react2.default.createElement(
    SocialBadgeWrapper,
    null,
    _react2.default.createElement(
      _AvatarContentHolder2.default,
      null,
      _react2.default.createElement(_SVGIcon2.default, {
        wrapperProps: {
          style: { backgroundColor: _Constants.SOCIAL_MAP[socialNetwork].color }
        },
        y: '70',
        icon: _Constants.SOCIAL_MAP[socialNetwork].icon
      })
    )
  );
};

SocialBadge.propTypes = {
  socialNetwork: _react.PropTypes.oneOf(Object.keys(_Constants.SOCIAL_MAP))
};

exports.default = SocialBadge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/SocialBadge.js
// module id = 1000
// module chunks = 2 3